<!--  -->
<template>
  <div>
    <!-- 头部大图 -->
    <section>
      <div class="headerBox">
        <div class="blackBg">
          <nav-header></nav-header>
          <div class="bigTitle">关于我们</div>
        </div>
      </div>
    </section>
    <section>
      <div class="contentBox">
        <!-- <div class="contentTitle">7动APP是一款专业和全面的盆底肌健康管理的软件。</div>
        <p>截止至2020年5月31日7动已经帮助全球超过200万用户改善盆底肌健康问题和提高男女生活质量。目前使用7动进行盆底肌锻炼的用户已经遍布中国、韩国、日本、马来西亚、新加坡、澳大利亚、加拿大、英国、美国、巴西等100多个国家,200多个城市.通过7动练习盆底肌课程累计总时长已经超过了3000万分钟。</p>
        <p>7动在苹果应用商店Apple App Store稳居健康健美畅销榜前50名榜单，我们是华为、腾讯、小米、OPPO、VIVO、百度和魅族的应用合作伙伴。</p>
        <p>
          目前，深圳已有2家大型集团公司和8家高新科技园推荐全公司和全园企业员工使用7动进行盆底肌健康管理服务，为企业员工解决久坐盆底肌功能障碍等健康问题。
          全国有33家产后康复中心、21家瑜伽馆、12家理疗推拿生活馆和7家母婴店推荐使用7动进行盆底肌修复训练。
        </p>
      </div> -->
      <div class="contentTitle">一、APP相关介绍</div>
      <p>APP名称：7动</p>
      <p>APP网站：https://pc7dong.com/</p>
      <p>开发商：深圳市金矿网络科技有限公司</p>
      <p>软件平台：PC、iOS、Android</p>
      <p>软件类型：国产软件</p>

      <div class="titleTow">APP简介：</div>
      <p>7动APP是深圳市金矿网络科技有限公司旗下的一款盆底肌健康管理的APP产品。截止2022年8月7动已经帮助全国超过500万+用户改善盆底肌功能问题和提高男女性生活质量。</p>
      <p>业务包含线上盆底肌修复课程，健康生活电商，锻炼社群平台，科普视频合作，知识付费学习，广告合作6大业务模块。</p>
      <p>7动为双版本运营，产品在国内名称为7动，在海外名称为 Crazy K。国内版多次获得App Store、各大安卓应用市场首页及主题推荐。</p>

      <div class="contentTitle">二、APP应用场景</div>
      <p>7动APP目前拥有健康测试报告，盆底肌早中晚训练模式，周目标挑战，精选优质科普视频和知识文章，社区挑战赛事，核心综合训练，训练徽章，经期管家，每周周报，睡眠模式，7动组团和7动商城。其中核心综合训练涵盖呼吸心法，修复骨盆，腹肌训练，Tabata训练，等10多种热门健身动作。</p>

      <div class="contentTitle"> 三、APP功能特点</div>
      <p>健康报告功能：自测了解自己的盆底肌情况,在家就可以进行AI智能盆底肌健康评估制定出专属你的训练计划。</p>
      <p>每日训练课表：是根据测试出的健康报告结果进行每日课表匹配。</p>
      <p>盆底肌专项训练：让盆底肌锻炼更专业,7动盆底肌专项功能整合了早中晚盆底肌训练，能让用户自行结合时间段进行跟练修复，还可以选择情景训练，其中的睡眠模式是首家让用户睡前都可以锻炼并准确记录锻炼效果的。</p>
      <p>社区板块：拉近和用户之间的关系,集中展示社区话题活动，可参与各种训练赛事，可自创立百人训练团，用户间交流和训练提醒分享健身成果，健身打卡，男女互问互答。</p>
      <p>学院板块：专家详解，专业知识分享,涵盖各类健康科普视频讲解和干货文章，解决你的困惑和好奇心。</p>
      <p>7动商城：健身装备更齐全,商城销售各类健身器材，辅助工具，满足用户在各类运动场景下的装备需求。</p>
      <p>经期管家：大姨妈记录工具,智能预期生理期，及时提醒月经的到来，帮助用户了解自己的生理状况。</p>
      <p>成就徽章：领取7动专属锻炼徽章,用户每达到一个里程碑可以点亮对应徽章，徽章还可以进行佩戴。</p>
      <p>每周周报：清楚了解锻炼成果,每周的训练周报，让用户清楚自己一周以来的变化。</p>

      <div class="contentTitle">四、产品优势</div>
      <div class="titleTow">打造产后“自测自练修复场”</div>
      <p>7动于8月13号发布了最新4.7版本，全面覆盖，睡眠，出行，随时随地想练就练。让宝妈在家也可以进行轻松修复，你还可以选择你想要的训练模式，进行情景训练。在家就可以线上做盆底肌评估和康复锻炼，以及支持APP端，微信小程序，电视TV端互通使用。</p>
      <div class="titleTow">名医专家为你保驾护航</div>
      <p>数十位三甲医院名医专家讲解各种各样的产后康复知识，围绕多个主题进行课程专题定制，依托于7动APP的教学资源，带你更全面的了解产后知识，两性知识，这些都是7动线上的健康服务内容，会为你的健康保驾护航。</p>
     <div class="titleTow">打造24小时陪伴式学习服务</div>
      <p>让运动不再是孤独的坚持，7动现有注册用户早已突破500万人，集中一二线城市，其中精准用户有孕期/产后宝妈，年轻白领，PC肌锻炼爱好者，产后私教等。因重视盆底肌而聚集在一起。用户可以选择加入社群，有任何不清楚的可以直接提问，帮助你解决困惑。同时也可以分享自己锻炼经验，互相加油督促，让更多人见证自己的成长。</p>
      <div class="titleTow">女性修复，男性增强，日常健身品类更丰富，更精细</div>
      <p>经过多年的产品迭代，7动成为了涵盖产后盆底肌修复，男性PC肌锻炼，Tabata训练，呼吸心法，训练记录，健身商城等功能在内的健康管理平台。同时社区互动形式也更加丰富，有话题讨论，锻炼赛事，男女互问互答等功能，如今7动并不局限于产后盆底肌领域，未来要做的是打造两性与健康全面发展的一个综合体。</p>

      <div class="contentTitle">五、最新动态</div>
      <div class="titleTow">线上盆底肌教学</div>
      <p>2022年5月，7动开展为期30天盆底肌修复训练营，依托于7动合作的授权医生，整理出的盆底肌修复教学资源，在线上社群对大家进行教学帮助，为产后想进行盆底功能修复，以及想锻炼盆底肌肉的群体，提供精准帮助，进行线上一对一疑难解答。</p>
      <div class="titleTow">自制女性，男性健康内容</div>
      <p>2022年7月，立足于知识付费的趋势，围绕着全名健身的各种需求，7动精准打造女性，男性健康垂直的自制内容，女性内容涵盖产前，产后等多项精准垂直内容，提供给孕妈妈更好的帮助，男性内容涵盖两性健康，日常健身等内容，7动以自制内容、自运营、全方位实现内容价值最大化是我们的目标。</p>
      <div class="titleTow">更便携快速的获取健康知识</div>
      <p>截止至2022上半年，7动社区中产出了大量的优质内容，供用户学习和交流，用户可以通过点击热门，查看热门健康知识推送。与此同时，7动也推出了“语音讲解”模块。邀请社区达人向用户进行答疑解惑，分享自己的健康经验，拍小视频演示运动过程，展示自己的训练内容与用户互动。</p>

      </div>
    </section>
    <!-- 页脚 -->
    <nav-footer></nav-footer>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NavFooter from "@/web/common/footer.vue";
import NavHeader from "@/web/common/header.vue";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    NavFooter,
    NavHeader
  },
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    var timer = setInterval(function() {
      let osTop = document.documentElement.scrollTop || document.body.scrollTop;
      let ispeed = Math.floor(-osTop / 5);
      document.documentElement.scrollTop = document.body.scrollTop =
        osTop + ispeed;
      this.isTop = true;
      if (osTop === 0) {
        clearInterval(timer);
      }
    }, 30);
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.titleTow{
  color: #3caff3;
  font-size: 18px;
  margin: 20px 0;
}
.headerBox {
  background-image: url("../assets/about.jpg");
  background-size: cover;
  height: 400px;
  position: relative;
}
img {
  width: 100%;
  height: 100%;
}
.blackBg {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}
.logoBox {
  position: absolute;
  width: 150px;
  height: 100px;
  left: 45%;
  top: 20px;
  cursor: pointer;
}
.bigTitle {
  position: absolute;
  font-size: 60px;
  color: #fff;
  width: 30%;
  letter-spacing: 10px;
  left: 35%;
  text-align: center;
  top: 50%;
  text-shadow: 1px 1px 1px #ccc;
}
.contentBox {
  width: 80%;
  margin: auto;
  margin-top: 50px;
}
.contentTitle {
  color: #3caff3;
  font-size: 25px;
  margin: 30px 0;
  // margin-left: 40px;
}
p {
  line-height: 1.5;
  padding: 10px 0;
  text-align: justify;
  // text-indent: 40px;
}
.navBar {
  display: flex;
  position: absolute;
  color: #fff;
  right: 10%;
  top: 10%;
  width: 250px;
}
.navBox {
  font-size: 20px;
  cursor: pointer;
  text-align: center;
  margin-right: 50px;
}
.navBar a {
  color: #fff;
}
.navBox:hover {
  border-bottom: 3px solid;
}
</style>



// WEBPACK FOOTER //
// src/web/about.vue